(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dazuma-all-collections"] && !Shopify.designMode) return;
  try {
    
(() => {
  'use strict';
  const tag = 'dazuma-all-collections';
  if (customElements.get(tag)) return;
  const normal = value => String(value).toLowerCase().normalize('NFKD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, ' ').trim().replace(/\b(bathroom|entryway|study|workspace|interior|exterior)\b/g, word => ({bathroom:'bath',entryway:'entry',study:'office',workspace:'office',interior:'indoor',exterior:'outdoor'}[word]));
  const termsMatch = (text, query) => normal(query).split(' ').filter(Boolean).every(term => text.includes(term));
  class DazumaDirectory extends HTMLElement {
    connectedCallback() {
      this.frame = requestAnimationFrame(() => { if (this.isConnected && !this.ready) this.initialize(); });
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.events?.abort();
      this.ready = false;
    }
    initialize() {
      this.ready = true;
      this.events = new AbortController();
      this.find = key => this.querySelector(`[data-dzc="${key}"]`);
      this.tabs = [...this.querySelectorAll('[data-dzc-tab]')];
      this.sceneButtons = [...this.querySelectorAll('[data-dzc-scene]')];
      this.groups = [...this.querySelectorAll('[data-dzc-group]')].map(node => ({node,id:node.dataset.dzcGroup,label:node.querySelector('h3').textContent,grid:node.querySelector('.dzc-card-grid'),more:node.querySelector('[data-dzc-more]'),expanded:false}));
      this.records = [...this.querySelectorAll('[data-dzc-card]')].map(node => {
        const group = node.closest('[data-dzc-group]').dataset.dzcGroup;
        return {node,group,environment:node.dataset.environment,scenes:node.dataset.scenes.split('|').filter(Boolean),label:node.querySelector('h4').textContent,order:Number(node.dataset.order),search:normal([node.querySelector('h4').textContent,node.dataset.handle,node.dataset.keywords,node.dataset.scenes,node.dataset.environment,this.groups.find(g=>g.id===group).label].join(' '))};
      });
      this.defaults = {environment:['all','indoor','outdoor'].includes(this.dataset.defaultEnvironment)?this.dataset.defaultEnvironment:'all',scene:'',type:'',q:'',sort:'curated'};
      this.state = {...this.defaults};
      this.readUrl();
      const listen = (target, event, fn) => target.addEventListener(event, fn, {signal:this.events.signal});
      this.tabs.forEach(tab => {
        listen(tab,'click', event => {event.preventDefault();this.switchEnvironment(tab.dataset.dzcTab);});
        listen(tab,'keydown',event => {
          if(!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
          event.preventDefault();
          const current=this.tabs.indexOf(tab);
          const next=event.key==='Home'?0:event.key==='End'?this.tabs.length-1:(current+(event.key==='ArrowRight'?1:-1)+this.tabs.length)%this.tabs.length;
          this.switchEnvironment(this.tabs[next].dataset.dzcTab);this.tabs[next].focus();
        });
      });
      this.sceneButtons.forEach(button=>listen(button,'click',()=>this.update({scene:this.state.scene===button.dataset.dzcScene?'':button.dataset.dzcScene,type:''})));
      listen(this.find('clear-space'),'click',()=>this.update({scene:'',type:'',q:''}));
      listen(this.find('search'),'input',event=>this.update({q:event.target.value.slice(0,120)}));
      listen(this.find('search'),'keydown',event=>{if(event.key==='Escape')this.update({q:''});});
      listen(this.find('clear-search'),'click',()=>{this.update({q:''});this.find('search').focus();});
      listen(this.find('type'),'change',event=>this.update({type:event.target.value}));
      listen(this.find('sort'),'change',event=>this.update({sort:event.target.value}));
      listen(this.find('active-filters'),'click',event=>{const button=event.target.closest('button');if(button?.dataset.clear)this.update({[button.dataset.clear]:''});else if(button?.hasAttribute('data-reset'))this.reset();});
      listen(this.find('empty-reset'),'click',()=>this.reset());
      listen(this.find('show-everything'),'click',()=>this.switchEnvironment('all'));
      this.groups.forEach(group=>listen(group.more,'click',()=>{group.expanded=!group.expanded;this.render();}));
      listen(this.find('type-nav'),'click',event=>{
        const anchor=event.target.closest('a');if(!anchor)return;
        event.preventDefault();
        const group=this.groups.find(g=>g.id===anchor.dataset.jumpGroup);if(!group)return;
        this.find('type-nav').querySelectorAll('a').forEach(a=>a.removeAttribute('aria-current'));
        anchor.setAttribute('aria-current','location');
        group.node.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});
      });
      listen(this.find('back-top'),'click',event=>{event.preventDefault();this.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});});
      listen(window,'popstate',()=>{this.readUrl();this.groups.forEach(g=>g.expanded=false);this.render();});
      this.querySelectorAll('.dzc-card-image img,.dzc-scene-image img').forEach(img=>{
        const fallback=()=>{if(img.parentElement.querySelector('.dzc-image-fallback'))return;img.hidden=true;img.parentElement.classList.add('dzc-image-unavailable');const note=document.createElement('span');note.className='dzc-image-fallback';note.textContent=img.alt;img.parentElement.prepend(note);};
        listen(img,'error',fallback);if(img.complete&&!img.naturalWidth)fallback();
      });
      this.setAttribute('data-enhanced','');
      this.render();
    }
    readUrl() {
      const params=new URL(location.href).searchParams;
      this.state={...this.defaults};
      const env=params.get('dzc_env');if(['all','indoor','outdoor'].includes(env))this.state.environment=env;
      const scene=params.get('dzc_space');if(this.sceneButtons.some(b=>b.dataset.dzcScene===scene&&(this.state.environment==='all'||b.dataset.environment===this.state.environment)))this.state.scene=scene;
      const type=params.get('dzc_type');if(this.groups.some(g=>g.id===type)&&this.records.some(r=>r.group===type&&this.inEnvironment(r)))this.state.type=type;
      this.state.q=(params.get('dzc_q')||'').slice(0,120);
      this.state.sort=params.get('dzc_sort')==='az'?'az':'curated';
    }
    saveUrl() {
      // Theme previews and market parameters are preserved; directory keys are namespaced.
      const url=new URL(location.href);
      ['dzc_env','dzc_space','dzc_type','dzc_q','dzc_sort'].forEach(key=>url.searchParams.delete(key));
      if(this.state.environment!==this.defaults.environment)url.searchParams.set('dzc_env',this.state.environment);
      if(this.state.scene)url.searchParams.set('dzc_space',this.state.scene);
      if(this.state.type)url.searchParams.set('dzc_type',this.state.type);
      if(this.state.q)url.searchParams.set('dzc_q',this.state.q);
      if(this.state.sort==='az')url.searchParams.set('dzc_sort','az');
      try{history.replaceState(null,'',url);}catch{/* In an embedded theme preview, filtering still works. */}
    }
    inEnvironment(record) {return this.state.environment==='all'||record.environment===this.state.environment||record.environment==='both';}
    matches(record,ignoreType=false) {return this.inEnvironment(record)&&(!this.state.scene||record.scenes.includes(this.state.scene))&&(ignoreType||!this.state.type||record.group===this.state.type)&&termsMatch(record.search,this.state.q);}
    update(values) {this.state={...this.state,...values};this.groups.forEach(g=>g.expanded=false);this.render();this.saveUrl();}
    reset() {this.update({scene:'',type:'',q:''});}
    switchEnvironment(environment) {this.update({...this.defaults,environment,sort:this.state.sort});}
    render() {
      const env=this.state.environment;
      const filtered=this.records.filter(record=>this.matches(record));
      const narrowed=Boolean(this.state.q||this.state.scene||this.state.type);
      this.dataset.currentEnvironment=env;
      this.find('panel').dataset.currentEnvironment=env;
      this.tabs.forEach(tab=>{const selected=tab.dataset.dzcTab===env;tab.setAttribute('aria-selected',String(selected));tab.tabIndex=selected?0:-1;});
      this.find('panel').setAttribute('aria-labelledby',this.tabs.find(tab=>tab.dataset.dzcTab===env).id);
      this.sceneButtons.forEach(button=>{
        button.hidden=(env!=='all'&&button.dataset.environment!==env)||!this.records.some(r=>this.inEnvironment(r)&&r.scenes.includes(button.dataset.dzcScene));
        button.setAttribute('aria-pressed',String(button.dataset.dzcScene===this.state.scene));
        button.querySelector('.dzc-scene-count').textContent=this.records.filter(r=>this.inEnvironment(r)&&r.scenes.includes(button.dataset.dzcScene)).length+' collections';
      });
      this.find('scene-heading').textContent=env==='indoor'?'Which room are you lighting?':env==='outdoor'?'Where will your light live?':'Start with the space you have in mind.';
      this.find('clear-space').hidden=!this.state.scene;
      if(this.find('search').value!==this.state.q)this.find('search').value=this.state.q;
      this.find('clear-search').hidden=!this.state.q;
      const typeSelect=this.find('type');
      typeSelect.replaceChildren(new Option('All collection types',''));
      this.groups.filter(g=>this.records.some(r=>r.group===g.id&&this.inEnvironment(r))).forEach(group=>{const n=this.records.filter(r=>r.group===group.id&&this.matches(r,true)).length;typeSelect.add(new Option(group.label+' ('+n+')',group.id));});
      if(![...typeSelect.options].some(o=>o.value===this.state.type))this.state.type='';
      typeSelect.value=this.state.type;this.find('sort').value=this.state.sort;
      const scene=this.sceneButtons.find(button=>button.dataset.dzcScene===this.state.scene);
      const pills=[];if(scene)pills.push(['scene',scene.dataset.label]);if(this.state.type)pills.push(['type',this.groups.find(g=>g.id===this.state.type).label]);if(this.state.q)pills.push(['q','“'+this.state.q+'”']);
      const filters=this.find('active-filters');filters.replaceChildren();filters.hidden=!pills.length;
      pills.forEach(([key,label])=>{const pill=document.createElement('span');pill.className='dzc-filter-pill';pill.append(document.createTextNode(label));const close=document.createElement('button');close.type='button';close.dataset.clear=key;close.textContent='×';close.setAttribute('aria-label','Remove '+label+' filter');pill.append(close);filters.append(pill);});
      if(pills.length){const clear=document.createElement('button');clear.type='button';clear.className='dzc-quiet-link';clear.dataset.reset='';clear.textContent='Clear all';filters.append(clear);}
      this.find('catalog-eyebrow').textContent=scene?'Shop by space':env==='all'?'The complete collection directory':'The '+env+' collection';
      this.find('catalog-title').textContent=scene?scene.dataset.label+' lighting':env==='all'?'Explore all collections':'Explore '+env+' lighting';
      this.find('results').textContent=filtered.length+' '+(filtered.length===1?'collection':'collections')+(narrowed?' matching your selection':' to explore');
      const allLink=this.find('shop-all');
      const shopHref=scene?scene.dataset.collectionHref:(env==='all'?this.dataset.allHref:env==='outdoor'?this.dataset.outdoorHref:this.dataset.indoorHref);
      allLink.hidden=!shopHref;
      if(shopHref)allLink.setAttribute('href',shopHref);else allLink.removeAttribute('href');
      allLink.textContent=scene?'Shop '+scene.dataset.label+' ↗':env==='all'?'Shop all lighting ↗':'Shop all '+env+' lighting ↗';
      this.records.forEach(record=>record.node.hidden=true);
      this.groups.forEach(group=>{
        const members=filtered.filter(record=>record.group===group.id);
        const sorted=[...members].sort(this.state.sort==='az'?(a,b)=>a.label.localeCompare(b.label):(a,b)=>a.order-b.order);
        group.node.hidden=!members.length;
        group.node.querySelector('.dzc-group-count').textContent=members.length+' '+(members.length===1?'collection':'collections');
        const expanded=narrowed||group.expanded;
        sorted.forEach((record,index)=>{group.grid.append(record.node);record.node.hidden=!expanded&&index>=8;});
        group.more.hidden=expanded&&narrowed||members.length<=8;
        group.more.textContent=group.expanded?'Show fewer collections':'Show all '+members.length+' collections ↓';
        group.more.setAttribute('aria-expanded',String(expanded));
        const nav=this.find('type-nav').querySelector(`[data-jump-group="${group.id}"]`);nav.hidden=!members.length;nav.querySelector('.dzc-nav-count').textContent=members.length;
      });
      this.find('type-index').hidden=!filtered.length;
      this.find('empty').hidden=Boolean(filtered.length);
      this.find('show-everything').hidden=env==='all'&&!narrowed;
    }
  }
  customElements.define(tag,DazumaDirectory);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dz-gift-finder"] && !Shopify.designMode) return;
  try {
    
(() => {
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const controls = root.querySelector('.dzgf__controls');
    const cards = Array.from(root.querySelectorAll('[data-gift-product]'));
    const results = root.querySelector('[data-results]');
    const count = root.querySelector('[data-count]');
    const empty = root.querySelector('[data-empty]');
    const more = root.querySelector('[data-more]');
    const reset = root.querySelector('[data-reset]');
    const browse = root.querySelector('[data-browse]');
    const budget = root.querySelector('[data-budget]');
    const state = { recipient: '', occasion: '', budget: 'all', expanded: false, open: false };
    controls.hidden = false;
    function apply() {
      let matched = 0;
      cards.forEach(card => {
        const price = Number(card.dataset.price);
        const recipientMatch = !state.recipient || card.dataset.recipients.split(',').includes(state.recipient);
        const occasionMatch = !state.occasion || card.dataset.occasions.split(',').includes(state.occasion);
        const budgetMatch = state.budget === 'all' ||
          (state.budget === 'under50' && price < 5000) ||
          (state.budget === '50to100' && price >= 5000 && price < 10000) ||
          (state.budget === '100to200' && price >= 10000 && price < 20000) ||
          (state.budget === '200to300' && price >= 20000 && price < 30000) ||
          (state.budget === '300plus' && price >= 30000);
        const match = recipientMatch && occasionMatch && budgetMatch;
        if (match) matched++;
        card.hidden = !match || (!state.expanded && matched > 8);
      });
      root.querySelectorAll('[data-group]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.value === state[button.dataset.group])));
      budget.value = state.budget;
      results.hidden = !state.open;
      count.textContent = state.open ? count.dataset.template.replace('[count]', matched) : count.dataset.default;
      empty.hidden = matched !== 0;
      more.hidden = matched <= 8 || state.expanded;
      reset.hidden = !state.open;
      browse.hidden = state.open;
    }
    controls.addEventListener('click', event => {
      const button = event.target.closest('[data-group]');
      if (!button) return;
      state[button.dataset.group] = button.dataset.value;
      state.open = Boolean(state.recipient || state.occasion || state.budget !== 'all');
      state.expanded = false;
      apply();
    });
    budget.addEventListener('change', () => {
      state.budget = budget.value;
      state.open = Boolean(state.recipient || state.occasion || state.budget !== 'all');
      state.expanded = false;
      apply();
    });
    root.addEventListener('gift:budget', event => {
      const value = event.detail?.budget;
      if (!Array.from(budget.options).some(option => option.value === value)) return;
      Object.assign(state, { recipient: '', occasion: '', budget: value, expanded: false, open: true });
      apply();
    });
    browse.addEventListener('click', () => { state.open = true; state.expanded = false; apply(); });
    reset.addEventListener('click', () => { Object.assign(state, {recipient:'', occasion:'', budget:'all', open:false, expanded:false}); apply(); });
    more.addEventListener('click', () => { state.expanded = true; apply(); });
    apply();
  }
  document.addEventListener('click', event => {
    const shortcut = event.target.closest('[data-gift-budget]');
    if (!shortcut) return;
    const finder = document.querySelector('[data-gift-finder]');
    if (finder) finder.dispatchEvent(new CustomEvent('gift:budget', { detail: { budget: shortcut.dataset.giftBudget } }));
  });
  document.querySelectorAll('[data-gift-finder]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-gift-finder]').forEach(init));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dz-moonlit-announcement"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dz-moonlit-announcement')) {
    customElements.define('dz-moonlit-announcement', class extends HTMLElement {
      connectedCallback() {
        this.setupFrame = requestAnimationFrame(() => this.setup());
      }
      setup() {
        if (!this.isConnected || this.controller) return;
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        if (!this.slides.length) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.index = 0;
        this.messages = this.querySelector('[data-messages]');
        this.counter = this.querySelector('[data-counter]');
        this.autoEnabled = this.dataset.autoplay === 'true' && this.slides.length > 1;
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.holds = new Set();
        this.querySelector('[data-previous]')?.addEventListener('click', () => this.show(this.index - 1), options);
        this.querySelector('[data-next]')?.addEventListener('click', () => this.show(this.index + 1), options);
        this.addEventListener('pointerenter', event => {
          if (event.pointerType === 'mouse') this.hold('hover', true);
        }, options);
        this.addEventListener('pointerleave', () => this.hold('hover', false), options);
        this.addEventListener('focusin', () => this.hold('focus', true), options);
        this.addEventListener('focusout', event => {
          if (!this.contains(event.relatedTarget)) this.hold('focus', false);
        }, options);
        this.addEventListener('keydown', event => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1));
        }, options);
        this.messages.addEventListener('pointerdown', event => {
          if (event.pointerType !== 'touch') return;
          this.touchStart = { x: event.clientX, y: event.clientY };
          this.hold('touch', true);
        }, options);
        this.messages.addEventListener('pointerup', event => {
          if (!this.touchStart) return;
          const dx = event.clientX - this.touchStart.x;
          const dy = event.clientY - this.touchStart.y;
          if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) {
            this.suppressClickUntil = Date.now() + 400;
            this.show(this.index + (dx < 0 ? 1 : -1));
          }
          this.touchStart = null;
          this.hold('touch', false);
        }, options);
        this.messages.addEventListener('pointercancel', () => {
          this.touchStart = null;
          this.hold('touch', false);
        }, options);
        this.messages.addEventListener('click', event => {
          if (Date.now() < (this.suppressClickUntil || 0)) event.preventDefault();
        }, options);
        document.addEventListener('visibilitychange', () => this.schedule(), options);
        this.motion.addEventListener('change', () => this.schedule(), options);
        document.addEventListener('shopify:block:select', event => {
          if (event.detail.sectionId !== this.dataset.sectionId) return;
          const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
          if (index < 0) return;
          this.hold('editor', true);
          this.show(index);
        }, options);
        document.addEventListener('shopify:block:deselect', event => {
          if (event.detail.sectionId === this.dataset.sectionId) this.hold('editor', false);
        }, options);
        this.dataset.ready = '';
        this.show(0);
      }
      hold(reason, active) {
        if (active) this.holds.add(reason);
        else this.holds.delete(reason);
        this.schedule();
      }
      show(index) {
        this.index = (index + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, position) => { slide.hidden = position !== this.index; });
        if (this.counter) this.counter.textContent = `${this.index + 1} / ${this.slides.length}`;
        this.schedule();
      }
      schedule() {
        clearTimeout(this.timer);
        const running = this.autoEnabled && !this.motion.matches && !this.holds.size && !document.hidden;
        this.messages.setAttribute('aria-live', running ? 'off' : 'polite');
        if (running) this.timer = setTimeout(() => this.show(this.index + 1), Math.max(3000, Number(this.dataset.speed) || 5000));
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.setupFrame);
        clearTimeout(this.timer);
        this.controller?.abort();
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dz-offers-hub"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root) => {
      if (root.dataset.offersInitialized === 'true') return;
      root.dataset.offersInitialized = 'true';
      const toast = root.querySelector('[data-offers-toast]');
      let toastTimer;
      const announce = (message) => {
        toast.textContent = message;
        toast.dataset.visible = 'true';
        clearTimeout(toastTimer);
        toastTimer = setTimeout(() => { toast.dataset.visible = 'false'; }, 2800);
      };
      const expireOffers = () => {
        const now = Date.now();
        root.querySelectorAll('[data-campaign-state="active"][data-campaign-end]').forEach((card) => {
          const deadline = Date.parse(card.dataset.campaignEnd);
          if (!Number.isFinite(deadline) || now < deadline) return;
          card.dataset.campaignState = 'expired';
          card.hidden = true;
          card.querySelectorAll('[data-offers-code]').forEach((button) => { button.disabled = true; });
          const item = document.createElement('li');
          const title = document.createElement('strong');
          const date = document.createElement('span');
          const badge = document.createElement('span');
          title.textContent = card.dataset.campaignTitle;
          date.textContent = card.dataset.campaignEndLabel;
          badge.textContent = root.dataset.expiredLabel;
          badge.className = 'dz-offers__badge dz-offers__badge--expired';
          item.append(title, date, badge);
          root.querySelector('[data-offers-expired-list]').append(item);
          root.querySelector('[data-offers-expired]').hidden = false;
        });
        const visibleCards = Array.from(root.querySelectorAll('[data-campaign-state]')).filter((card) => !card.hidden).length;
        root.querySelector('[data-offers-empty]').hidden = visibleCards > 0;
        root.querySelector('.dz-offers__campaign-grid').style.setProperty('--dz-campaign-columns', Math.max(1, Math.min(4, visibleCards)));
      };
      expireOffers();
      const interval = setInterval(() => {
        if (!root.isConnected) { clearInterval(interval); return; }
        expireOffers();
      }, 60000);
      const checkOnVisible = () => {
        if (!root.isConnected) { document.removeEventListener('visibilitychange', checkOnVisible); return; }
        if (!document.hidden) expireOffers();
      };
      document.addEventListener('visibilitychange', checkOnVisible);
      root.querySelectorAll('[data-offers-code]').forEach((button) => {
        button.addEventListener('click', async () => {
          expireOffers();
          if (button.disabled || button.closest('[data-campaign-state]')?.hidden) return;
          const code = button.dataset.offersCode;
          let copied = false;
          if (window.isSecureContext && navigator.clipboard) {
            try { await navigator.clipboard.writeText(code); copied = true; } catch (_) {}
          }
          if (!copied) {
            const field = document.createElement('textarea');
            field.value = code;
            field.style.cssText = 'position:fixed;top:0;left:-9999px;opacity:0';
            field.setAttribute('readonly', '');
            root.append(field);
            field.select();
            try { copied = document.execCommand('copy'); } catch (_) {}
            field.remove();
            button.focus({ preventScroll: true });
          }
          if (!copied) { announce(root.dataset.copyFailure); return; }
          button.textContent = root.dataset.copiedLabel;
          announce(root.dataset.copySuccess.replace('__CODE__', code));
          setTimeout(() => { button.textContent = root.dataset.copyLabel; }, 2000);
        });
      });
      const tabs = Array.from(root.querySelectorAll('[data-offers-tab]'));
      const activate = (tab, focus) => {
        tabs.forEach((candidate) => {
          const selected = candidate === tab;
          candidate.setAttribute('aria-selected', String(selected));
          candidate.tabIndex = selected ? 0 : -1;
          const panel = root.querySelector('#' + CSS.escape(candidate.getAttribute('aria-controls')));
          if (panel) panel.hidden = !selected;
        });
        if (focus) tab.focus({ preventScroll: true });
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(tab, false));
        tab.addEventListener('keydown', (event) => {
          let target;
          if (event.key === 'ArrowRight') target = tabs[(index + 1) % tabs.length];
          else if (event.key === 'ArrowLeft') target = tabs[(index + tabs.length - 1) % tabs.length];
          else if (event.key === 'Home') target = tabs[0];
          else if (event.key === 'End') target = tabs[tabs.length - 1];
          if (target) { event.preventDefault(); activate(target, true); }
        });
      });
      document.addEventListener('shopify:block:select', (event) => {
        const panel = event.target.closest('.dz-offers__panel');
        if (!panel || !root.contains(panel)) return;
        const tab = tabs.find((candidate) => candidate.getAttribute('aria-controls') === panel.id);
        if (tab) activate(tab, false);
      });
    };
    const initializeAll = (scope) => {
      if (scope.matches?.('[data-dz-offers]')) initialize(scope);
      scope.querySelectorAll('[data-dz-offers]').forEach(initialize);
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeAll(document));
    else initializeAll(document);
    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dz-sale-products"] && !Shopify.designMode) return;
  try {
    



/* Shared once across product grids and all four builders.



 * Cart writes finish before this background read starts. Never repeat an add



 * because a header or drawer refresh failed, and never open a drawer here.



 */



if (!window.DazumaSaleCartSync) {



  window.DazumaSaleCartSync = {



    running: null,



    queued: false,



    cartUrl: '/cart',







    refresh(cartUrl) {



      this.cartUrl = cartUrl || '/cart';



      this.queued = true;



      if (this.running) return this.running;



      this.running = this.refreshQueued().finally(() => {



        this.running = null;



      });



      return this.running;



    },







    async refreshQueued() {



      do {



        this.queued = false;



        try {



          const response = await fetch(this.cartUrl + '.js', {



            method: 'GET',



            credentials: 'same-origin',



            cache: 'no-store',



            headers: { 'Accept': 'application/json' }



          });



          if (!response.ok) continue;



          const cart = await response.json();



          if (!Number.isInteger(cart.item_count)) continue;







          // Hyper's count method updates the badge without a cart-items event,



          // which would require rendered sections and could move keyboard focus.



          document.querySelectorAll('cart-count').forEach(counter => {



            if (typeof counter.onCartUpdate === 'function') {



              counter.onCartUpdate({ cart: cart });



            } else {



              counter.textContent = String(cart.item_count);



              counter.hidden = cart.item_count === 0;



            }



          });



          document.dispatchEvent(new CustomEvent('cart:updated', {



            detail: { cart: cart }



          }));







          // This is Hyper's native refresh event. open:false leaves the



          // shopper in place; Hyper fetches and replaces its drawer contents.



          document.dispatchEvent(new CustomEvent('cart:refresh', {



            detail: { open: false }



          }));



        } catch (error) {



          // The add was already confirmed. A read failure must not resubmit it.



          document.dispatchEvent(new CustomEvent('dz-sale:cart-refresh-error'));



        }



      } while (this.queued);



    }



  };



}







if (!customElements.get('dz-sale-product-add')) {



  customElements.define('dz-sale-product-add', class extends HTMLElement {



    connectedCallback() {



      if (this.initialized) return;



      this.initialized = true;



      this.button = this.querySelector('button');



      this.status = this.querySelector('[role="status"]');



      this.pending = false;



      this.uncertain = false;



      this.button.disabled = false;



      this.button.addEventListener('click', () => this.addProduct());



    }







    async addProduct() {



      if (this.pending || this.uncertain) return;



      const variantId = Number(this.dataset.variant);



      if (!Number.isSafeInteger(variantId) || variantId <= 0) return;



      this.pending = true;



      this.button.disabled = true;



      this.button.setAttribute('aria-busy', 'true');



      this.status.textContent = 'Adding…';



      const controller = new AbortController();



      const timeout = window.setTimeout(() => controller.abort(), 20000);



      try {



        const response = await fetch(this.dataset.addUrl, {



          method: 'POST',



          credentials: 'same-origin',



          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },



          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),



          signal: controller.signal



        });



        const result = await response.json();



        if (!response.ok || !Array.isArray(result.items) || !result.items.some(item => Number(item.variant_id || item.id) === variantId)) {



          throw new Error('The cart change could not be confirmed.');



        }



        this.status.textContent = 'Added to cart';



        window.DazumaSaleCartSync.refresh(this.dataset.cartUrl);



      } catch (error) {



        this.uncertain = true;



        this.status.textContent = 'Please check your cart before adding again. We could not confirm this change.';



      } finally {



        window.clearTimeout(timeout);



        this.pending = false;



        this.button.removeAttribute('aria-busy');



        this.button.disabled = this.uncertain;



      }



    }



  });



}




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dz-sale-set"] && !Shopify.designMode) return;
  try {
    
/* Shared once across product grids and all four builders.
 * Cart writes finish before this background read starts. Never repeat an add
 * because a header or drawer refresh failed, and never open a drawer here.
 */
if (!window.DazumaSaleCartSync) {
  window.DazumaSaleCartSync = {
    running: null,
    queued: false,
    cartUrl: '/cart',

    refresh(cartUrl) {
      this.cartUrl = cartUrl || '/cart';
      this.queued = true;
      if (this.running) return this.running;
      this.running = this.refreshQueued().finally(() => {
        this.running = null;
      });
      return this.running;
    },

    async refreshQueued() {
      do {
        this.queued = false;
        try {
          const response = await fetch(this.cartUrl + '.js', {
            method: 'GET',
            credentials: 'same-origin',
            cache: 'no-store',
            headers: { 'Accept': 'application/json' }
          });
          if (!response.ok) continue;
          const cart = await response.json();
          if (!Number.isInteger(cart.item_count)) continue;

          // Hyper's count method updates the badge without a cart-items event,
          // which would require rendered sections and could move keyboard focus.
          document.querySelectorAll('cart-count').forEach(counter => {
            if (typeof counter.onCartUpdate === 'function') {
              counter.onCartUpdate({ cart: cart });
            } else {
              counter.textContent = String(cart.item_count);
              counter.hidden = cart.item_count === 0;
            }
          });
          document.dispatchEvent(new CustomEvent('cart:updated', {
            detail: { cart: cart }
          }));

          // This is Hyper's native refresh event. open:false leaves the
          // shopper in place; Hyper fetches and replaces its drawer contents.
          document.dispatchEvent(new CustomEvent('cart:refresh', {
            detail: { open: false }
          }));
        } catch (error) {
          // The add was already confirmed. A read failure must not resubmit it.
          document.dispatchEvent(new CustomEvent('dz-sale:cart-refresh-error'));
        }
      } while (this.queued);
    }
  };
}

/* One controller per section. A/B/C submit a complete fixed set, never nine products. */
if (!customElements.get('dz-fixed-sets')) {
  customElements.define('dz-fixed-sets', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) {
        return;
      }
      this.initialized = true;
      this.pending = false;
      this.uncertain = false;
      this.tabs = Array.from(this.querySelectorAll('[data-tab-trigger]'));
      this.panels = Array.from(this.querySelectorAll('[data-panel]'));
      this.activeTab = 'a';
      this.money = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency: this.dataset.currency || 'USD'
      });

      this.tabs.forEach(tab => {
        tab.addEventListener('click', () => {
          this.activateTab(tab.dataset.tabTrigger, false);
        });
        tab.addEventListener('keydown', event => {
          const currentIndex = this.tabs.indexOf(tab);
          let nextIndex = currentIndex;
          if (event.key === 'ArrowRight') {
            nextIndex = (currentIndex + 1) % this.tabs.length;
          } else if (event.key === 'ArrowLeft') {
            nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
          } else if (event.key === 'Home') {
            nextIndex = 0;
          } else if (event.key === 'End') {
            nextIndex = this.tabs.length - 1;
          } else {
            return;
          }
          event.preventDefault();
          this.activateTab(this.tabs[nextIndex].dataset.tabTrigger, true);
        });
      });

      this.panels.forEach(panel => {
        const button = panel.querySelector('[data-add]');
        if (button) {
          button.addEventListener('click', () => {
            this.addSet(panel.dataset.panel);
          });
        }
      });
      this.addEventListener('shopify:block:select', event => {
        const panel = event.target.closest('[data-panel]');
        if (panel && this.contains(panel)) {
          this.activateTab(panel.dataset.panel, false);
        }
      });
      this.updateAll();
      this.activateTab('a', false);
    }

    activateTab(identifier, moveFocus) {
      const activePanel = this.panels.find(panel => panel.dataset.panel === identifier);
      if (!activePanel) {
        return;
      }
      this.activeTab = identifier;
      this.dataset.tab = identifier;
      this.tabs.forEach(tab => {
        const selected = tab.dataset.tabTrigger === identifier;
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
        if (selected && moveFocus) {
          tab.focus();
        }
      });
      this.panels.forEach(panel => {
        panel.hidden = panel !== activePanel;
      });
      const badge = this.querySelector('[data-offer-badge]');
      const setDescription = this.querySelector('[data-set-description]');
      const customDescription = this.querySelector('[data-custom-description]');
      if (badge) {
        // D is navigation to a collection, not a fixed set with a promised discount.
        const selection = identifier === 'd' ? null : this.selection(activePanel);
        badge.hidden = identifier === 'd' || !selection.discountApplies;
      }
      if (setDescription) {
        setDescription.hidden = identifier === 'd';
      }
      if (customDescription) {
        customDescription.hidden = identifier !== 'd';
      }
    }

    selection(panel) {
      const cards = Array.from(panel.querySelectorAll('[data-set-item]'));
      const items = new Map();
      let complete = panel.dataset.panel !== 'd' && cards.length === 3;
      let allEligible = true;
      let subtotal = 0;
      let compareSubtotal = 0;

      cards.forEach(card => {
        const identifier = Number(card.dataset.variant);
        const quantity = Number(card.dataset.quantity);
        const price = Number(card.dataset.price);
        const comparePrice = Number(card.dataset.compare);
        const stock = Number(card.dataset.stock);
        const valid = Number.isSafeInteger(identifier) && identifier > 0 &&
          Number.isSafeInteger(quantity) && quantity >= 1 && quantity <= 99 &&
          Number.isSafeInteger(price) && price >= 0 &&
          Number.isSafeInteger(stock) && stock >= 0 &&
          card.dataset.available === 'true';
        if (!valid) {
          complete = false;
          return;
        }
        const existing = items.get(identifier);
        const combinedQuantity = quantity + (existing ? existing.quantity : 0);
        const availableStock = existing ? Math.min(existing.stock, stock) : stock;
        if (combinedQuantity > availableStock) {
          complete = false;
        }
        items.set(identifier, {
          id: identifier,
          quantity: combinedQuantity,
          stock: availableStock
        });
        subtotal += price * quantity;
        compareSubtotal += (Number.isSafeInteger(comparePrice) ? Math.max(price, comparePrice) : price) * quantity;
        if (card.dataset.eligible !== 'true') {
          allEligible = false;
        }
      });

      if (!Number.isSafeInteger(subtotal) || !Number.isSafeInteger(compareSubtotal)) {
        complete = false;
      }
      const rate = Number(this.dataset.rate);
      const code = (this.dataset.code || '').trim();
      const discountApplies = complete && allEligible && this.dataset.offer === 'true' &&
        code.length > 0 && Number.isFinite(rate) && rate > 0 && rate <= 100;
      const extraSaving = discountApplies ? Math.round(subtotal * rate / 100) : 0;
      return {
        complete: complete,
        discountApplies: discountApplies,
        subtotal: subtotal,
        originalTotal: compareSubtotal,
        extraSaving: extraSaving,
        total: subtotal - extraSaving,
        saleSaving: compareSubtotal - subtotal,
        totalSaving: compareSubtotal - subtotal + extraSaving,
        items: Array.from(items.values()).map(item => ({
          id: item.id,
          quantity: item.quantity
        }))
      };
    }

    updateAll() {
      this.panels.forEach(panel => {
        const button = panel.querySelector('[data-add]');
        if (!button) {
          return;
        }
        const selection = this.selection(panel);
        const values = {
          '[data-original-total]': selection.originalTotal,
          '[data-subtotal]': selection.subtotal,
          '[data-extra-saving]': selection.extraSaving,
          '[data-total]': selection.total,
          '[data-sale-saving]': selection.saleSaving,
          '[data-total-saving]': selection.totalSaving
        };
        Object.entries(values).forEach(([selector, value]) => {
          const output = panel.querySelector(selector);
          if (output) {
            const prefix = selector === '[data-extra-saving]' ? '−' : '';
            output.textContent = selection.complete ? prefix + this.money.format(value / 100) : '—';
          }
        });
        const originalRow = panel.querySelector('[data-original-row]');
        const finalLabel = panel.querySelector('[data-final-label]');
        if (originalRow) {
          originalRow.hidden = !selection.complete || selection.saleSaving <= 0;
        }
        if (finalLabel) {
          finalLabel.textContent = selection.discountApplies ? finalLabel.dataset.offerLabel : finalLabel.dataset.regularLabel;
        }
        const savingRow = panel.querySelector('[data-savings-row]');
        const codeNote = panel.querySelector('[data-code-note]');
        const breakdown = panel.querySelector('[data-breakdown]');
        if (savingRow) {
          savingRow.hidden = !selection.discountApplies;
        }
        if (codeNote) {
          codeNote.hidden = !selection.discountApplies;
        }
        if (breakdown) {
          breakdown.hidden = !selection.complete || selection.totalSaving <= 0;
        }
        button.disabled = this.pending || this.uncertain || !selection.complete;
        if (!selection.complete && !this.uncertain) {
          panel.querySelector('[data-status]').textContent = this.dataset.unavailable || 'This complete set is currently unavailable.';
        }
      });
    }

    async addSet(identifier) {
      if (this.pending || this.uncertain || identifier === 'd' || identifier !== this.activeTab) {
        return;
      }
      const panel = this.panels.find(candidate => candidate.dataset.panel === identifier);
      if (!panel) {
        return;
      }
      const selection = this.selection(panel);
      if (!selection.complete) {
        this.updateAll();
        return;
      }
      const button = panel.querySelector('[data-add]');
      const status = panel.querySelector('[data-status]');
      const cartLink = panel.querySelector('[data-check-cart]');
      const controller = new AbortController();
      const timer = window.setTimeout(() => controller.abort(), 25000);
      this.pending = true;
      button.setAttribute('aria-busy', 'true');
      button.textContent = this.dataset.loading || 'Adding…';
      status.textContent = '';
      cartLink.hidden = true;
      this.updateAll();

      try {
        const response = await fetch(this.dataset.addUrl, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ items: selection.items }),
          signal: controller.signal
        });
        const result = await response.json();
        if (!response.ok || !Array.isArray(result.items)) {
          throw new Error('The complete cart addition was not confirmed.');
        }
        const returnedIdentifiers = new Set(result.items.map(item => Number(item.variant_id || item.id)));
        if (!selection.items.every(item => returnedIdentifiers.has(item.id))) {
          throw new Error('Some set items were not confirmed.');
        }
        status.textContent = this.dataset.added || 'Set added to your cart.';
        if (selection.discountApplies) {
          status.textContent += ' Enter ' + this.dataset.code + ' at checkout for the extra savings.';
        }
        // Cart badge/drawer refresh happens after confirmation, without blocking
        // feedback or replaying the POST if the theme refresh is unavailable.
        Promise.resolve().then(() => {
          if (window.DazumaSaleCartSync) {
            return window.DazumaSaleCartSync.refresh(this.dataset.cartUrl);
          }
        }).catch(() => {
          document.dispatchEvent(new CustomEvent('dz-sale:cart-refresh-error'));
        });
      } catch (error) {
        // A failed or timed-out request may have changed the cart. Do not blindly
        // retry a batch and risk adding the same lights twice.
        this.uncertain = true;
        this.panels.forEach(candidate => {
          const candidateStatus = candidate.querySelector('[data-status]');
          const candidateLink = candidate.querySelector('[data-check-cart]');
          if (candidateStatus) {
            candidateStatus.textContent = 'We could not confirm the complete addition. Check your cart before trying again.';
          }
          if (candidateLink) {
            candidateLink.hidden = false;
          }
        });
      } finally {
        window.clearTimeout(timer);
        this.pending = false;
        button.setAttribute('aria-busy', 'false');
        button.textContent = this.dataset.ready || 'Add set to cart';
        this.updateAll();
      }
    }
  });
}
if (!window.DazumaSeasonalAnchors) {
  window.DazumaSeasonalAnchors = true;
  const openSeason = (hash, scroll = false) => {
    if (!hash || hash.length < 2) return;
    let id;
    try { id = decodeURIComponent(hash.slice(1)); } catch (error) { return; }
    const target = document.getElementById(id);
    const details = target?.querySelector('[data-dz-seasonal]') || target?.closest('[data-dz-seasonal]');
    if (!details) return;
    details.open = true;
    if (scroll) requestAnimationFrame(() => target.scrollIntoView({block:'start', behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'}));
  };
  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href]');
    if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
    const url = new URL(link.href, window.location.href);
    if (url.origin === window.location.origin && url.pathname === window.location.pathname) openSeason(url.hash, true);
  });
  window.addEventListener('hashchange', () => openSeason(window.location.hash, true));
  document.addEventListener('shopify:section:select', (event) => {
    const details = event.target.querySelector('[data-dz-seasonal]');
    if (details) details.open = true;
  });
  openSeason(window.location.hash, true);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dz-series-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dz-series-hero-title')) {
    customElements.define('dz-series-hero-title', class extends HTMLElement {
      connectedCallback() {
        this.heading = this.querySelector('h1');
        this.text = this.heading && this.heading.querySelector('span');
        if (!this.text) return;

        this.scheduleFit = () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => {
            if (this.isConnected) this.fitHeading();
          });
        };
        this.lastWidth = -1;
        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver((entries) => {
            const width = entries[0].contentRect.width;
            if (Math.abs(width - this.lastWidth) > 0.1) {
              this.lastWidth = width;
              this.scheduleFit();
            }
          });
          this.resizeObserver.observe(this);
        }
        this.textObserver = new MutationObserver(this.scheduleFit);
        this.textObserver.observe(this.text, { childList: true, characterData: true, subtree: true });
        window.addEventListener('resize', this.scheduleFit, { passive: true });
        if (document.fonts) {
          document.fonts.ready.then(() => {
            if (this.isConnected) this.scheduleFit();
          });
          document.fonts.addEventListener('loadingdone', this.scheduleFit);
        }
        this.scheduleFit();
      }

      fitHeading() {
        // Reset first so the current desktop/mobile setting remains the maximum.
        this.heading.style.removeProperty('font-size');
        const maximumSize = parseFloat(getComputedStyle(this.heading).fontSize);
        const availableWidth = this.heading.getBoundingClientRect().width - 2;
        if (availableWidth <= 0 || !Number.isFinite(maximumSize)) return;
        const minimumSize = Math.min(18, maximumSize);

        // Measure actual theme typography, including letter spacing and loaded fonts.
        this.text.style.display = 'inline-block';
        this.text.style.whiteSpace = 'nowrap';
        let lower = minimumSize;
        let upper = maximumSize;
        if (this.text.getBoundingClientRect().width > availableWidth) {
          this.heading.style.fontSize = lower + 'px';
          if (this.text.getBoundingClientRect().width <= availableWidth) {
            for (let iteration = 0; iteration < 12; iteration += 1) {
              const candidate = (lower + upper) / 2;
              this.heading.style.fontSize = candidate + 'px';
              if (this.text.getBoundingClientRect().width <= availableWidth) {
                lower = candidate;
              } else {
                upper = candidate;
              }
            }
          }
          this.heading.style.fontSize = (Math.floor(lower * 100) / 100) + 'px';
        }
        // Extremely long titles wrap at the readable minimum; nothing is truncated.
        this.text.style.removeProperty('display');
        this.text.style.removeProperty('white-space');
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        if (this.resizeObserver) this.resizeObserver.disconnect();
        if (this.textObserver) this.textObserver.disconnect();
        window.removeEventListener('resize', this.scheduleFit);
        if (document.fonts && this.scheduleFit) {
          document.fonts.removeEventListener('loadingdone', this.scheduleFit);
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
